export default class FlightSearchInput {
  tripType: 'oneway' | 'roundtrip' = 'oneway';
  fromAirportId: string = null;
  toAirportId: string = null;
  departureDate: string = null;
  returnDate: string = null;
  adultCount: number = 1;
  childCount: number = 0;
  infantCount: number = 0;
}
